import React, {Component} from 'react';
import {observer} from "mobx-react";

class Color extends Component {
  render() {
    if(this.props.value) {
      return (
        <span className="up12 splice s-nowrap">
          <span className="cell s-shrink s-middle">
            <span style={{background: this.props.value, width: 15, height: 15}}
                  className="db solid1 bo-w1 vam rad200"></span>
          </span>
          <span className="cell b5 fs12 s-shrink  s-middle pleft5">
            {this.props.value}
          </span>
        </span>
      )
    }
    return null;
  }
}

export default observer(Color);